/* co-home-3 "Most loved" carousel controls — bespoke prev/next arrows + a draggable
   scrollbar thumb, wired to the co-flickity instance. The arrows live outside the slider's
   masked (overflow:hidden) frame and the scrollbar is fully custom, so neither fits
   co-flickity's built-in arrow wiring — we listen for its `co-flickity:init` event instead.
   That event re-fires on the editor's section:load, so controls re-wire cleanly. Handlers are
   stored on their elements and removed before re-adding (the editor can reuse the same nodes),
   and the drag uses pointer capture so there are no document-level listeners to leak. */
(function () {
  if (window.__coHome3Controls) return;
  window.__coHome3Controls = true;

  document.addEventListener('co-flickity:init', function (e) {
    var slider = e.target;
    if (!slider.matches || !slider.matches('.co-home-3-slider')) return;
    var flkty = e.detail && e.detail.flickity;
    if (!flkty) return;

    var wrapper = slider.closest('.co-home-3-slider-wrapper');
    var frame = slider.closest('.co-home-3-frame');
    var prevBtn = wrapper && wrapper.querySelector('.co-home-3-slider-prev button');
    var nextBtn = wrapper && wrapper.querySelector('.co-home-3-slider-next button');
    var scrollbar = frame && frame.querySelector('.co-home-3-slider-scrollbar');
    var thumb = frame && frame.querySelector('.co-home-3-slider-scrollbar__thumb');

    var currentThumbX = 0;
    var dragging = false;

    function maxScrollX() { return Math.max(0, flkty.slideableWidth - flkty.size.width); }
    function maxThumbX() { return scrollbar && thumb ? scrollbar.offsetWidth - thumb.offsetWidth : 0; }
    function setThumbX(x) { currentThumbX = x; if (thumb) thumb.style.transform = 'translateX(' + x + 'px)'; }

    function updateThumbSize() {
      if (!thumb || !flkty.slideableWidth) return;
      thumb.style.width = Math.min((flkty.size.width / flkty.slideableWidth) * 100, 100) + '%';
    }
    function updateNav() {
      var x = -flkty.x;
      var max = maxScrollX();
      if (prevBtn) prevBtn.disabled = x <= 2;
      if (nextBtn) nextBtn.disabled = x >= max - 2;
    }

    /* (Re)bind a click handler, replacing any from a previous init on a reused node. */
    function bindClick(btn, fn) {
      if (!btn) return;
      if (btn.__coH3Click) btn.removeEventListener('click', btn.__coH3Click);
      btn.__coH3Click = fn;
      btn.addEventListener('click', fn);
    }
    bindClick(prevBtn, function () { flkty.previous(); });
    bindClick(nextBtn, function () { flkty.next(); });

    flkty.on('scroll', function (progress) {
      if (!dragging) setThumbX(Math.max(0, Math.min(1, progress)) * maxThumbX());
      updateNav();
    });
    flkty.on('resize', updateThumbSize);
    flkty.on('settle', updateNav);
    updateThumbSize();
    updateNav();

    if (thumb) {
      if (thumb.__coH3Down) thumb.removeEventListener('pointerdown', thumb.__coH3Down);
      thumb.__coH3Down = function (ev) {
        dragging = true;
        try { thumb.setPointerCapture(ev.pointerId); } catch (_) {}
        var startX = ev.clientX;
        var startThumb = currentThumbX;
        flkty.velocity = 0;
        flkty.isAnimating = false;
        ev.preventDefault();

        function move(mv) {
          if (!dragging) return;
          var max = maxThumbX();
          var nx = Math.max(0, Math.min(max, startThumb + (mv.clientX - startX)));
          setThumbX(nx);
          var p = max ? nx / max : 0;
          flkty.x = -p * (flkty.slideableWidth - flkty.size.width);
          flkty.velocity = 0;
          flkty.positionSlider();
          updateNav();
        }
        function end(up) {
          dragging = false;
          try { thumb.releasePointerCapture(up.pointerId); } catch (_) {}
          thumb.removeEventListener('pointermove', move);
          thumb.removeEventListener('pointerup', end);
          thumb.removeEventListener('pointercancel', end);
          flkty.velocity = 0;
          updateNav();
        }
        thumb.addEventListener('pointermove', move);
        thumb.addEventListener('pointerup', end);
        thumb.addEventListener('pointercancel', end);
      };
      thumb.addEventListener('pointerdown', thumb.__coH3Down);
    }
  });
})();
